import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { filter } from 'lodash';
import FA from 'react-fontawesome';
import styles from './styles.css';
import AccountLogo from '../../modules/Feedback/components/account-logo';
import ProgressBar from '../progress-bar';
import { loadOwner } from './actions';

class OwnerCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
      errors: null,
      owner: props.owner,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    if (this.state.loading) {
      return;
    }
    this.setState({ loading: true, loaded: false }, () => {
      loadOwner(this.props.owner.user_id)
      .then(
        ({ owner }) => {
          this.setState({ owner, loading: false, loaded: true });
        },
        (errors) => {
          this.setState({ loading: false, errors });
        },
      );
    });
  }

  renderLogo() {
    const {
      owner,
    } = this.state;

    if (!owner) {
      return null;
    }

    const { email } = owner;
    const domain = email ? email.split('@')[1] : null;
    const website = domain && domain.length ? `http://${domain}` : null;

    const account = { website, account_name: domain, account_id: owner.user_id };
    return (
      <div className="pull-left">
        <div className={styles.logo}>
          <AccountLogo account={account} />
        </div>
      </div>
    );
  }

  renderContent() {
    const {
      owner,
    } = this.state;

    if (!owner) {
      return null;
    }

    const { url } = this.props;

    const isHashed = owner.is_hashed;

    const profiles = filter(owner.profiles || [], { has_feedback: true });
    


    const hasProfiles = profiles && profiles.length > 0;
    // const hasMultiProfiles = profiles && profiles.length > 1;




    let name = (<strong>{owner.first_name} {owner.last_name}</strong>);
    if (url && url.length > 0) {
      name = (<a href={url} target="_blank" rel="noreferrer">{name} <FA name="external-link" /></a>);
    }

    return (
      <div>
        <div className={`${styles.header} clearfix`}>
          {!isHashed && this.renderLogo()}
          <div className={styles.heading}>
            <p>{name}</p>
            {owner.title !== null && owner.title.length > 0 && <p>{owner.title}</p>}
            {owner.company_name && owner.company_name.length > 0 && <p><em>Company</em></p>}
          </div>
        </div>
        <div className={styles.body}>
          <table className="table table-condensed" style={{ margin: 0 }}>
            <tbody>
              <tr>
                <th>Email:</th>
                <td>
                  {owner.email && owner.email.length > 0 && <a href={`mailto:${owner.email}`}>{owner.email}</a>}
                </td>
              </tr>
              <tr>
                <th>Phone:</th>
                <td>{(owner.phone && owner.phone.length > 0 ? owner.phone : 'N/A')}</td>
              </tr>
              {hasProfiles &&
                <tr>
                  <th>View:</th>
                  <td>
                    {profiles.map((profile) => {
                      return (
                        <div key={profile.id}>
                          <a
                            href={profile.sales_profile_url}
                            rel="noreferrer"
                            target="_blank"
                          >
                            TruVoice Sales Profile
                          </a>
                        </div>
                      );
                    })}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderLoading() {
    return (
      <div>
        <p />
        <ProgressBar />
        <p />
      </div>
    );
  }

  renderErrors() {
    return (
      <div className="alert alert-danger">
        Please try again.
      </div>
    );
  }

  render() {
    const { 
      loading, loaded,
    } = this.state;
    if (loading) {
      return this.renderLoading();
    }
    if (!loaded) {
      return this.renderErrors();
    }

    return this.renderContent()
  }
}

OwnerCell.propTypes = {
  owner: PropTypes.shape({
    user_id: PropTypes.string.isRequired,
    profiles: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  url: PropTypes.string,
};
OwnerCell.defaultProps = {
  url: null,
};
OwnerCell.contextTypes = {
};


export default OwnerCell;
